<template>
  <v-snackbar
    :value="globalSnackBarText"
    :top="true"
    color="white"
    :timeout="3000"
    style="color:black"
    @input="snackBarInputEventHandler"
  >
    {{ globalSnackBarText }}
    <v-icon
      color="green"
    >
      mdi-check
    </v-icon>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('app', ['globalSnackBarText'])
  },
  methods: {
    // スナックバーがタイムアウトし消えるときにスナックバーテキストもクリアする。
    snackBarInputEventHandler (e) {
      if (!e) { this.$store.commit('app/setGlobalSnackBarText', '') }
    }
  }
}
</script>
